// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as VehicleDetailsApiModel from "../api-model/VehicleDetailsApiModel.bs.js";

function detailsToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        key: e.key,
                        value: e.value
                      };
              }), data);
}

function iconsToEntity(data) {
  return {
          map_marker: data.map_marker,
          selected: data.selected,
          deselected: data.deselected
        };
}

function serviceToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        is_enabled: e.is_enabled,
                        service_type: e.service_type
                      };
              }), data);
}

function vasToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        vas_type: e.vas_type,
                        off_messages: e.off_messages,
                        services: serviceToEntity(e.services)
                      };
              }), data);
}

function allowedGoodsToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        id: e.id,
                        name: e.name
                      };
              }), data);
}

function onDemandToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        id: e.id,
                        display_name: e.display_name,
                        details: detailsToEntity(e.details),
                        icons: iconsToEntity(e.icons),
                        allowed_goods_type_names: allowedGoodsToEntity(e.allowed_goods_type_names),
                        value_added_services: vasToEntity(e.value_added_services)
                      };
              }), data);
}

function vehicleIdsToEntity(data) {
  return $$Array.map((function (v) {
                return v.id;
              }), data);
}

function apiModelToEntity(data) {
  return {
          vehicles: {
            on_demand: onDemandToEntity(data.vehicles.on_demand),
            vehicle_ids: $$Array.map((function (v) {
                    return v.id;
                  }), data.vehicles.on_demand)
          }
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(VehicleDetailsApiModel.t_decode(json), "VehicleDetailsEntityMapper.res"));
}

export {
  detailsToEntity ,
  iconsToEntity ,
  serviceToEntity ,
  vasToEntity ,
  allowedGoodsToEntity ,
  onDemandToEntity ,
  vehicleIdsToEntity ,
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
